module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-512x512-a2eead22d872b0b6316f6e62f4b87335.png";